import ActionBtn from '@/components/ActionBtn'
import { Block, Image } from '@/components/crRender'
import React, { useState } from 'react'
import { FileUploadField } from '../../../shared'
import placeholderImg from '@/assets/images/Not_available.jpg'

const TechFiles = ({ tech, updateTechnology }) => {

    const [isEditImg , setIsEditImg] = useState(false)
    return (
        <>
            <Block isRender={!isEditImg} className="image-container">
                <Image src={`${window.API_URL}${tech.attachmentPath}`} placeholder={placeholderImg} />

                <ActionBtn
                    icon="qlementine-icons:cross-16"
                    className="remove-tech-btn remove-tech-image-btn pointer"
                    onApply={() =>setIsEditImg(true)}/>
            </Block>

            <Block isRender={!!isEditImg}>
                <FileUploadField
                    className="col-lg-12"
                    formHandler={(name, value) => updateTechnology(tech.id, name, value)}
                    name="picture"
                    id={`technology-picture-${tech.id}`}
                    accept="image/*"
                    maxFiles={1}
                    value={tech.picture || ''} />
            </Block>
        </>
    )
}

export default TechFiles